import React, { useEffect, useState } from "react";
import client, { apiErr } from "../../lib/api";
import { Panel, Spinner, StatCard } from "../ui-kit";
import { toast } from "sonner";
import { Empty, money, fmtDate, PayStatus } from "./shared";

export default function TeamEarnings() {
  const [d, setD] = useState(null);
  useEffect(() => { client.get("/tm/earnings").then(({ data }) => setD(data)).catch((e) => toast.error(apiErr(e))); }, []);
  if (!d) return <Spinner />;
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard testid="earn-total" label="Total Earnings" value={money(d.total)} accent="gold" />
        <StatCard testid="earn-paid" label="Paid" value={money(d.paid_total)} accent="bull" />
        <StatCard testid="earn-pending" label="Pending" value={money(d.pending_total)} />
        <StatCard testid="earn-share" label="Your Share" value={`${d.share_pct}%`} sub="of broker commission" />
      </div>
      <Panel title="By Period" testid="earn-by-period">
        {d.by_period.length === 0 ? <Empty testid="earn-empty" text="Abhi tak koi commission report upload nahi hui. Admin report upload karega to earnings yahan dikhegi." /> :
          d.by_period.map((p) => (
            <div key={p.period} data-testid={`earn-period-${p.period}`} className="px-4 py-3 border-b border-[color:var(--border-subtle)] last:border-0">
              <div className="flex flex-wrap items-center gap-3">
                <span className="text-white font-medium">{p.period}</span>
                <PayStatus status={p.status} testid={`earn-status-${p.period}`} />
                <span className="text-xs text-slate-500">{p.rows} rows · gross {money(p.gross)}</span>
                <span className="ml-auto font-mono text-gold text-lg">{money(p.amount)}</span>
              </div>
              <div className="text-xs text-slate-400 mt-1">Paid <span className="font-mono text-bull">{money(p.paid)}</span> · Pending <span className="font-mono text-slate-200">{money(p.pending)}</span></div>
              {p.payouts.map((po) => (
                <div key={po.id} className="text-[11px] text-slate-500 mt-0.5">Paid {money(po.amount)} on {fmtDate(po.paid_at)}{po.note ? ` · ${po.note}` : ""}</div>
              ))}
            </div>
          ))}
      </Panel>
      {d.rows.length > 0 && (
        <Panel title="Client-wise Breakdown" testid="earn-rows">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-[11px] uppercase tracking-widest text-slate-500 text-left">
                {["Period", "Client", "MT5 ID", "Broker", "Gross", "Share", "You Earn", "Status", "Uploaded"].map((h) => <th key={h} className="px-4 py-2 font-normal">{h}</th>)}
              </tr></thead>
              <tbody>{d.rows.map((e) => (
                <tr key={e.id} className="border-t border-[color:var(--border-subtle)]">
                  <td className="px-4 py-2 text-slate-300">{e.period}</td>
                  <td className="px-4 py-2 text-white">{e.client_name}</td>
                  <td className="px-4 py-2 font-mono text-slate-300">{e.mt5_id}</td>
                  <td className="px-4 py-2 text-slate-400">{e.broker}</td>
                  <td className="px-4 py-2 font-mono text-slate-300">{money(e.gross)}</td>
                  <td className="px-4 py-2 font-mono text-slate-400">{e.share_pct}%</td>
                  <td className="px-4 py-2 font-mono text-gold">{money(e.amount)}</td>
                  <td className="px-4 py-2"><PayStatus status={e.payout_id ? "Paid" : "Pending"} /></td>
                  <td className="px-4 py-2 text-xs text-slate-500">{fmtDate(e.created_at)}</td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </Panel>
      )}
    </div>
  );
}
